import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { APP_ROUTE } from 'app/app-routing.constant';

@Component({
  selector: 'kh-guest-account-required-guard',
  templateUrl: './guest-account-required-guard.component.html',
  styleUrls: ['./guest-account-required-guard.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GuestAccountRequiredGuardComponent {
  private readonly bsModalRef = inject(BsModalRef);

  public login = APP_ROUTE.LOGIN.route();
  public registerTeacher = APP_ROUTE.REGISTER.TEACHER.route();

  public closeModal(): void {
    this.bsModalRef.hide();
  }
}
